export default __webpack_public_path__ + "static/media/Person.4502a14a.svg";